import { connect, useDispatch } from 'react-redux';
import { Dispatch } from 'redux';

import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';
import { RootActions } from 'CorePackage/MainModule/types/RootActions';
import { knmPmClosePlanKnmMessageModal } from 'KnmPmPackage/MainModule/actions/knmPmActions';
import {
  getKnmPmPlanKnmMessageModalId,
  getKnmPmPlanKnmMessageModalType,
  getKnmPmPlanKnmMessageModalVisible,
} from 'KnmPmPackage/MainModule/selectors/knmPmSelectors';
import { Modal } from 'UIPackage/ModalModule/components/Modal';
import { ModalBody } from 'UIPackage/ModalModule/components/ModalBody';
import { KnmPmPlanKnmMessageTypesEnum } from 'KnmPmPackage/MainModule/enums/KnmPmPlanKnmMessageTypesEnum';

import styles from './PmReasons.module.scss';

interface IPmReasonsPlanKnmMessageModalStoreProps {
  visible: boolean;
  id?: string;
  type?: KnmPmPlanKnmMessageTypesEnum;
}

const PmReasonsPlanKnmMessageModalWithoutStore = ({ visible, id, type }: IPmReasonsPlanKnmMessageModalStoreProps) => {
  const dispatch = useDispatch<Dispatch<RootActions>>();

  const onClose = () => {
    dispatch(knmPmClosePlanKnmMessageModal());
  };

  const renderMessage = () => {
    switch (type) {
      case KnmPmPlanKnmMessageTypesEnum.EXCLUDE_CONTROLLING_SUBJECT:
        return (
          <span>
            Контролируемое лицо будет исключено из планового КНМ <span className="shared-no-wrap-text">№ {id}</span> по
            причине проведения профилактического визита, не предусматривающего возможности отказа
          </span>
        );
      case KnmPmPlanKnmMessageTypesEnum.EXCLUDE_KNM:
        return (
          <span>
            Плановое КНМ <span className="shared-no-wrap-text">№ {id}</span> будет исключено из плана по причине
            проведения профилактического визита, не предусматривающего возможности отказа
          </span>
        );

      default:
        return null;
    }
  };

  if (type == null || id == null) {
    return null;
  }

  return (
    <Modal visible={visible} onClose={onClose} isOutsideClick modalBodyClassName={styles.PlanKnmPlanKnmModal}>
      <ModalBody size={'content'}>{renderMessage()}</ModalBody>
    </Modal>
  );
};

const mapStateToProps = (state: IRootState): IPmReasonsPlanKnmMessageModalStoreProps => ({
  visible: getKnmPmPlanKnmMessageModalVisible(state),
  type: getKnmPmPlanKnmMessageModalType(state),
  id: getKnmPmPlanKnmMessageModalId(state),
});

export const PmReasonsPlanKnmMessageModal = connect(mapStateToProps)(PmReasonsPlanKnmMessageModalWithoutStore);
